import React, { useCallback } from 'react'

import PropTypes from 'prop-types'

import isNil from 'lodash/isNil'

import I18n from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'

import { Container, MainText, HeaderText } from './styles'

const ConfirmationModal = (props) => {
  const { id, open, handleClose, message, title, buttonTitle, buttonProps, onConfirm } = props

  const handleConfirm = useCallback(
    () => {
      onConfirm()
      handleClose()
    },
    [handleClose, onConfirm]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      hideHeader
      maxWidth="xs"
      FooterComponent={ () => (
        <>
          <Button
            id="cancel"
            onClick={ handleClose }
            variant="text"
            color="darkGrey"
          >
            <I18n>cancel</I18n>
          </Button>
          <Button
            id="confirm"
            onClick={ handleConfirm }
            variant="text"
            color="error"
            { ...buttonProps }
          >
            {isNil(buttonTitle) ? <I18n>delete</I18n> : buttonTitle}
          </Button>
        </>
      ) }
    >
      <Container>

        <HeaderText>
          {title}
        </HeaderText>

        {message && (
          <MainText>
            {message}
          </MainText>
        )}
      </Container>
    </Modal>
  )
}

ConfirmationModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  buttonTitle: PropTypes.string,
  buttonProps: PropTypes.object
}

ConfirmationModal.defaultProps = {
  message: null,
  title: null,
  buttonTitle: null,
  buttonProps: {}
}

export default ConfirmationModal
